(function () {
    'use strict';

    const initSizeChartModal = () => {
        // Encontra todas as imagens de tabela de medidas
        const sizeChartImages = document.querySelectorAll('.size-chart-image img');
        
        if (sizeChartImages.length === 0) return;

        sizeChartImages.forEach(img => {
            img.addEventListener('click', function() {
                const modal = this.closest('.product-about').querySelector('.size-chart-modal');
                if (modal) {
                    modal.classList.add('active');
                    document.body.style.overflow = 'hidden';
                }
            });
        });

        // Fecha o modal ao clicar no X
        const closeButtons = document.querySelectorAll('.size-chart-modal__close');
        closeButtons.forEach(btn => {
            btn.addEventListener('click', function() {
                const modal = this.closest('.size-chart-modal');
                if (modal) {
                    modal.classList.remove('active');
                    document.body.style.overflow = '';
                }
            });
        });

        // Fecha o modal ao clicar fora da imagem
        const modals = document.querySelectorAll('.size-chart-modal');
        modals.forEach(modal => {
            modal.addEventListener('click', function(e) {
                if (e.target === this) {
                    this.classList.remove('active');
                    document.body.style.overflow = '';
                }
            });
        });

        // Fecha o modal ao pressionar ESC
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                const activeModal = document.querySelector('.size-chart-modal.active');
                if (activeModal) {
                    activeModal.classList.remove('active');
                    document.body.style.overflow = '';
                }
            }
        });
    };

    // Inicializa quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSizeChartModal);
    } else {
        initSizeChartModal();
    }

    // Reinicializa quando uma seção é carregada no editor do tema
    document.addEventListener('shopify:section:load', function() {
        initSizeChartModal();
    });
})();